module.exports = __webpack_public_path__ + "static/img/QB200.d8205c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/QB200.png
// module id = B21f
// module chunks = 2